<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_iv"></a><span class="smallcaps">NEW YORK UNIVERSITY PRESS</span><br/>New York and London<br/><span class="weblink"><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></span></p>
<p class="copyright1">© 2007 by New York University<br/>All rights reserved</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data<br/>Hamm, Mark S.<br/>Terrorism as crime : from Oklahoma City to Al-Qaeda and beyond / Mark S. Hamm.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN-13: 978-0-8147-3695-1 (cloth : alk. paper)<br/>ISBN-10: 0-8147-3695-5 (cloth : alk. paper)<br/>ISBN-13: 978-0-8147-3696-8 (pbk. : alk. paper)<br/>ISBN-10: 0-8147-3696-3 (pbk. : alk. paper)<br/>1. Terrorism.      2. Radicalism.     3. Terrorism—United States.<br/>4. Radicalism—United States.      5. Criminology.  I. Title.<br/>HV6431.H364    2006<br/>364.1—dc22           2006029835</p>
<p class="copyright1">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability.</p>
<p class="copyright1">Manufactured in the United States of America<br/>c 10 9 8 7 6 5 4 3 2 1<br/>p 10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?8e7dd382